/**
Specifies the initial amount of data returned per page. Requesting additional data beyond this limit increments the amount by this specified number.
*/
export const PAGE_SIZE = 30;

/**
 * How many miliseconds will last a delay between typing in search field and fetching data.
 */
export const DEBOUNCE_SEARCH_BY = 500;
